import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// material
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';
// components
import { MotionContainer, varBounceIn } from '../components/animate';
import Page from '../components/Page';
import { signOutStart } from '../redux/auth/auth.actions';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function Page405Admin() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(signOutStart());
  });
  return (
    <RootStyle title="Désolé, Non autorisé  | Gestion des plaintes">
      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" paragraph>
                Désolé, votre session a expirée !
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>
              Désolé, Si vous n’avez rien fait sur la page pendant un certain temps, le serveur met
              fin à votre session
            </Typography>

            <motion.div variants={varBounceIn}>
              <Box
                component="img"
                src="/static/illustrations/access_denied.jpg"
                sx={{ height: 400, mx: 'auto', my: { xs: 5, sm: 10 } }}
              />
            </motion.div>

            <Button to="/admin" size="large" variant="contained" component={RouterLink}>
              Accueil
            </Button>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
